export default __webpack_public_path__ + "static/reflect-1f85d5c77c29af78df1d2e998b32286b.mp4";